import { ComponentPropsWithoutRef } from 'react';

export const EqualizerIcon = ({
  ...props
}: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 16 14" fill="none">
      <path
        d="M5.5 8.875a2.5 2.5 0 0 1 2.421 1.875h6.954a.625.625 0 0 1 .113 1.24l-.113.01-6.954.001a2.5 2.5 0 0 1-4.842 0L1.125 12a.625.625 0 0 1-.112-1.24l.112-.01H3.08A2.5 2.5 0 0 1 5.5 8.875Zm0 1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm5-10A2.5 2.5 0 0 1 12.921 2h1.954a.625.625 0 0 1 .113 1.24l-.113.01-1.954.001a2.5 2.5 0 0 1-4.842 0L1.125 3.25a.625.625 0 0 1-.112-1.24L1.125 2H8.08A2.5 2.5 0 0 1 10.5.125Zm0 1.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
        fill="#000000"
      />
    </svg>
  );
};
